function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { XS } from "constants/sizes";
import { useCallback, useMemo, useState, useEffect } from "react";
import { CAMPAIGN_PRODUCT_COOKIE } from "constants/cookies";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import ClustersSignup from "segments/desktop/core-components/clusters-signup/clusters-signup";
import { SIGNUP_BUTTON_TYPE } from "segments/desktop/core-components/button/button-consts";
import { StyledSideBySideParagraphAndTagsHomepageFirstFoldComponent } from "./side-by-side-paragraph-and-tags-homepage-first-fold-component.scss";
import TagsAndAssetsComponent from "./tags-and-assets/tags-and-assets-component";
import { CLUSTER_TO_TAG_ICON_MAP, getClusterProduct, NAME_TO_ICON } from "./consts";
import { withAbTests } from "contexts/ab-tests-context";
import { CAMPAIGN_PRODUCT_FIRST_FOLD_CONFIG } from "segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/config/campaign-product-first-fold-config";
import { trackEvent } from "services/bigbrain-service";
import { FIRST_FOLD_DISPLAYED } from "constants/bigbrain-event-types";
const SIGNUP_BUTTON_ANIMATION_START_TIME = 100;
const SideBySideParagraphAndTagsHomepageFirstFoldComponent = ({ fullParagraph, gap, tagsTitle, tags, fullParagraphAdvancedConfig, defaultImage, minHeight, fullParagraphTopMargin, enabledDefaultImageAnimation, useTagsClusterCTA, flipUseCasesAndAssets, verticalView, imageMaxWidth, resizingFactor, useCasesTopMargin, assetsAndTagsExtraSpace, startAtCenter, tagsTitleFontSize, blurDefaultImage, tagsTitleAlignment, setStartShowingStickyHeader, isInView, abTests, simulateCampaignProductHomepageFirstFoldTest, cookies })=>{
    var _fullParagraph_topic, _fullParagraph_topic1, _fullParagraph_topic_image, _fullParagraph_topic2, _fullParagraph_buttonConfig;
    const campaignProduct = cookies === null || cookies === void 0 ? void 0 : cookies[CAMPAIGN_PRODUCT_COOKIE];
    const getCampaignProductConfiguration = ()=>{
        const shouldDisplayCampaign = campaignProduct && simulateCampaignProductHomepageFirstFoldTest;
        return shouldDisplayCampaign ? CAMPAIGN_PRODUCT_FIRST_FOLD_CONFIG[campaignProduct] : null;
    };
    const campaignProductConfig = getCampaignProductConfiguration();
    const getGetTagIcon = useCallback((tag)=>NAME_TO_ICON[tag === null || tag === void 0 ? void 0 : tag.tagIconName] || CLUSTER_TO_TAG_ICON_MAP[tag === null || tag === void 0 ? void 0 : tag.overridePageCluster] || CLUSTER_TO_TAG_ICON_MAP[tag === null || tag === void 0 ? void 0 : tag.overridePageSubCluster], []);
    const assetTags = useMemo(()=>tags === null || tags === void 0 ? void 0 : tags.map((_param)=>{
            var { tagText, tagColor } = _param, tag = _object_without_properties(_param, [
                "tagText",
                "tagColor"
            ]);
            return _object_spread_props(_object_spread({}, tag), {
                text: tagText,
                tagColor,
                Icon: getGetTagIcon(tag)
            });
        }), [
        tags,
        getGetTagIcon
    ]);
    const preSelectedTag = useMemo(()=>{
        return assetTags === null || assetTags === void 0 ? void 0 : assetTags.find((tag)=>tag.text === (campaignProductConfig === null || campaignProductConfig === void 0 ? void 0 : campaignProductConfig.defaultSelectedTag));
    }, [
        tags,
        campaignProductConfig
    ]);
    const initialSelectedClusters = useMemo(()=>{
        if (preSelectedTag) {
            return [
                {
                    tagBackgroundColor: preSelectedTag.tagColor,
                    overridePageSubCluster: preSelectedTag.overridePageSubCluster,
                    overridePageCluster: preSelectedTag.overridePageCluster
                }
            ];
        }
        return [];
    }, [
        preSelectedTag,
        tags
    ]);
    const [selectedClusters, setSelectedClusters] = useState(initialSelectedClusters);
    const [wasClusterSelected, setWasClusterSelected] = useState(initialSelectedClusters.length > 0);
    useEffect(()=>{
        trackEvent(FIRST_FOLD_DISPLAYED, {
            "type": campaignProductConfig ? campaignProduct : "default"
        });
    }, []);
    useEffect(()=>{
        setStartShowingStickyHeader(!isInView);
    }, [
        isInView,
        setStartShowingStickyHeader
    ]);
    const selectedProducts = useMemo(()=>selectedClusters.map(({ overridePageCluster })=>getClusterProduct(overridePageCluster)), [
        selectedClusters
    ]);
    const onClustersChange = (selectedTags)=>{
        setSelectedClusters(selectedTags === null || selectedTags === void 0 ? void 0 : selectedTags.map(({ tagColor, overridePageCluster, overridePageSubCluster })=>({
                tagBackgroundColor: tagColor,
                overridePageSubCluster,
                overridePageCluster
            })));
        selectedTags && setTimeout(()=>setWasClusterSelected(true), SIGNUP_BUTTON_ANIMATION_START_TIME);
    };
    const renderClusterCTA = (props)=>/*#__PURE__*/ _jsx(ClustersSignup, _object_spread_props(_object_spread({}, props), {
            wasClusterSelected: wasClusterSelected,
            clusters: selectedClusters,
            selectedProducts: selectedProducts
        }));
    const renderTagsClusterCTA = ()=>{
        const extraData = {
            component: "TagsAndAssetsComponent"
        };
        return renderClusterCTA({
            extraData,
            buttonSize: XS
        });
    };
    const modifiedFullParagraph = _object_spread(_object_spread_props(_object_spread({}, fullParagraph), {
        title: (campaignProductConfig === null || campaignProductConfig === void 0 ? void 0 : campaignProductConfig.title) || fullParagraph.title,
        body: (campaignProductConfig === null || campaignProductConfig === void 0 ? void 0 : campaignProductConfig.subTitle) || fullParagraph.body,
        topic: _object_spread({}, fullParagraph === null || fullParagraph === void 0 ? void 0 : fullParagraph.topic, (fullParagraph === null || fullParagraph === void 0 ? void 0 : (_fullParagraph_topic = fullParagraph.topic) === null || _fullParagraph_topic === void 0 ? void 0 : _fullParagraph_topic.image) && {
            image: _object_spread_props(_object_spread({}, fullParagraph === null || fullParagraph === void 0 ? void 0 : (_fullParagraph_topic1 = fullParagraph.topic) === null || _fullParagraph_topic1 === void 0 ? void 0 : _fullParagraph_topic1.image), {
                src: (campaignProductConfig === null || campaignProductConfig === void 0 ? void 0 : campaignProductConfig.topicImage) || (fullParagraph === null || fullParagraph === void 0 ? void 0 : (_fullParagraph_topic2 = fullParagraph.topic) === null || _fullParagraph_topic2 === void 0 ? void 0 : (_fullParagraph_topic_image = _fullParagraph_topic2.image) === null || _fullParagraph_topic_image === void 0 ? void 0 : _fullParagraph_topic_image.src)
            })
        })
    }), (fullParagraph === null || fullParagraph === void 0 ? void 0 : fullParagraph.buttonConfig) && {
        buttonConfig: _object_spread({}, fullParagraph.buttonConfig, ((_fullParagraph_buttonConfig = fullParagraph.buttonConfig) === null || _fullParagraph_buttonConfig === void 0 ? void 0 : _fullParagraph_buttonConfig.additionalText) && {
            additionalText: (campaignProductConfig === null || campaignProductConfig === void 0 ? void 0 : campaignProductConfig.buttonBelowText) || fullParagraph.buttonConfig.additionalText
        })
    });
    const renderFullParagraphClusterCTA = ()=>{
        var _modifiedFullParagraph_buttonConfig;
        return (modifiedFullParagraph === null || modifiedFullParagraph === void 0 ? void 0 : (_modifiedFullParagraph_buttonConfig = modifiedFullParagraph.buttonConfig) === null || _modifiedFullParagraph_buttonConfig === void 0 ? void 0 : _modifiedFullParagraph_buttonConfig.buttonType) === SIGNUP_BUTTON_TYPE ? renderClusterCTA(modifiedFullParagraph === null || modifiedFullParagraph === void 0 ? void 0 : modifiedFullParagraph.buttonConfig) : null;
    };
    return /*#__PURE__*/ _jsxs(StyledSideBySideParagraphAndTagsHomepageFirstFoldComponent, {
        gap: gap,
        resizingFactor: resizingFactor,
        minHeight: minHeight,
        fullParagraphTopMargin: fullParagraphTopMargin,
        tagsTitleFontSize: tagsTitleFontSize,
        className: classnames("side-by-side-paragraph-and-tags-homepage-first-fold-component", {
            "vertical-view": verticalView
        }),
        onAnimationEnd: ()=>setWasClusterSelected(false),
        children: [
            /*#__PURE__*/ _jsx(FullParagraph, _object_spread({
                renderButton: renderFullParagraphClusterCTA
            }, modifiedFullParagraph, fullParagraphAdvancedConfig)),
            /*#__PURE__*/ _jsx(TagsAndAssetsComponent, {
                assetsAndTagsExtraSpace: assetsAndTagsExtraSpace,
                flipUseCasesAndAssets: flipUseCasesAndAssets,
                onClustersChange: onClustersChange,
                tagsTitle: tagsTitle,
                useCasesTopMargin: useCasesTopMargin,
                tags: assetTags,
                imageMaxWidth: imageMaxWidth,
                renderCta: useTagsClusterCTA && renderTagsClusterCTA,
                defaultImage: defaultImage,
                enabledDefaultImageAnimation: enabledDefaultImageAnimation,
                startAtCenter: startAtCenter,
                blurDefaultImage: blurDefaultImage,
                tagsTitleAlignment: tagsTitleAlignment,
                preSelectedTag: preSelectedTag
            })
        ]
    });
};
export default withAbTests(SideBySideParagraphAndTagsHomepageFirstFoldComponent);
